export abstract class SingleInstanceClass {
  // In Typescript, static fields are shared between derived classes
  private static _instances = new Map<Function, SingleInstanceClass>();

  constructor() {
    const constructor = this.constructor;

    if (SingleInstanceClass._instances.has(constructor)) {
      throw new Error(
        `Class ${constructor.name} already exists, cannot create a duplicate.`,
      );
    }

    SingleInstanceClass._instances.set(constructor, this);
  }
}
